import axios from "../api";
import { objectToParam } from "../../libs/utils";

export async function getTransportRequests(registrationId, params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(
    `/registrations/${registrationId}/transport-requests?` + parameters
  );
  return data;
}

export async function getAllTransportRequests(params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(`/transport-requests?` + parameters);
  return data;
}

export async function getTransportRequest(registrationId, id) {
  const { data } = await axios.get(
    `/registrations/${registrationId}/transport-requests/` + id
  );
  return data;
}

export async function createTransportRequest(registrationId, values) {
  const { data } = await axios.post(
    `/registrations/${registrationId}/transport-requests`,
    values
  );
  return data;
}

export async function deleteTransportRequest(registrationId, id) {
  const { data } = await axios.delete(
    `/registrations/${registrationId}/transport-requests/` + id
  );
  return data;
}

export async function adminDeleteTransportRequest(id) {
  const { data } = await axios.delete(`/transport-requests/` + id);
  return data;
}

export async function approveTransportRequest(
  registrationId,
  transportRequestId,
  values
) {
  const { data } = await axios.post(
    `/registrations/${registrationId}/transport-requests/${transportRequestId}/approve`,
    values
  );
  return data;
}

export async function rejectTransportRequest(
  registrationId,
  transportRequestId,
  values
) {
  const { data } = await axios.post(
    `/registrations/${registrationId}/transport-requests/${transportRequestId}/reject`,
    values
  );
  return data;
}

export async function pendTransportRequest(
  registrationId,
  transportRequestId,
  values
) {
  const { data } = await axios.post(
    `/registrations/${registrationId}/transport-requests/${transportRequestId}/pend`,
    values
  );
  return data;
}
